import styled from 'styled-components'
import dayjs from 'dayjs'

import type { components } from '../../../constants/schema'

import { ModalWrap } from '../../../components/modal/ModalWrap'
import { Content } from '../../../components/container/Content'
import { AlignCenterItem, RowBetween } from '../../../components/common'
import { Button } from '../../../components/button'
import { Text } from '../../../components/text'
import { StyledProductCard } from '../../../components/card/ProductCard'
import { ProductInfoCard } from '../../../components/card/ProductInfoCard'
import { DivideLine } from '../../../components/divide'
import { Footer, FOOTER_MIN_HEIGHT } from '../../../components/footer'
import { Header } from '../../../components/header'

interface OrderSuccessModalProps {
  orderData?: components['schemas']['UserProductDto']
  onDismiss: () => void
}

export function OrderSuccessModal({ orderData, onDismiss }: OrderSuccessModalProps) {
  return (
    <ModalWrap>
      <Header type="SUB" title="청약 신청 완료" isBack={false} />
      <StyledContent backgroundColor="gray_1">
        <ProductInfoCard>
          <ProductInfoBox>
            <ProductImage radius={8}>
              <img src={orderData?.product?.imageUri} alt={orderData?.product?.name} />
            </ProductImage>
            <ProductNameBox>
              <Text size={18} weight={600}>
                {orderData?.product?.artist}
              </Text>
              <Text size={14} color="text_secondary">
                {orderData?.product?.name}
              </Text>
            </ProductNameBox>
          </ProductInfoBox>
          <DivideLine />
          <Text size={18} weight={600}>
            청약 신청 정보
          </Text>
          <RowBetween>
            <Text size={16} color="text_secondary">
              거래 일시
            </Text>
            <Text size={16} weight={500}>
              {dayjs(orderData?.createdDate).format('YYYY.MM.DD HH:mm:ss')}
            </Text>
          </RowBetween>
          <RowBetween>
            <Text size={16} color="text_secondary">
              주당 공모가 액
            </Text>
            <Text size={16} weight={500}>
              {orderData?.offerPrice?.toLocaleString()}원
            </Text>
          </RowBetween>
          <RowBetween>
            <Text size={16} color="text_secondary">
              청약 신청 수량
            </Text>
            <Text size={16} weight={500} color="primary_5">
              {orderData?.subscriptionShares.toLocaleString()}주
            </Text>
          </RowBetween>
          <RowBetween>
            <Text size={16} color="text_secondary">
              총 신청 금액
            </Text>
            <Text size={16} weight={500}>
              {((orderData?.offerPrice ?? 0) * (orderData?.subscriptionShares ?? 0)).toLocaleString()}원
            </Text>
          </RowBetween>
        </ProductInfoCard>
      </StyledContent>
      <Footer>
        <Button type="primary" size="large" block={true} onClick={onDismiss}>
          닫기
        </Button>
      </Footer>
    </ModalWrap>
  )
}

const StyledContent = styled(Content)`
  padding: 16px 16px ${FOOTER_MIN_HEIGHT}px;
`

const ProductInfoBox = styled(AlignCenterItem)`
  gap: 16px;
`

const ProductImage = styled(StyledProductCard)`
  width: 100px;
  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const ProductNameBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
